__turbopack_context__.v({
  "ctaButtonWrapper": "Actions-module-scss-module__Ldc1va__ctaButtonWrapper",
  "hamburgerWrapper": "Actions-module-scss-module__Ldc1va__hamburgerWrapper",
});
